import { render } from "./TalentMenagement.vue?vue&type=template&id=1dc30068&scoped=true&lang=html"
import script from "./TalentMenagement.vue?vue&type=script&lang=js"
export * from "./TalentMenagement.vue?vue&type=script&lang=js"

import "./TalentMenagement.vue?vue&type=style&index=0&id=1dc30068&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-1dc30068"

export default script